import React, { memo } from 'react'

import Root from '../../../Root'

const RootWrapper = (props) => {
  return <Root {...props} />
}

export default memo(RootWrapper)
